import { Send } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { formatCurrency } from '@/lib/format'
import { cn } from '@/lib/utils'
import { primaryBtnClass } from './styles'

interface Props {
  amountIncl: number
  saving: boolean
  onSaveAndSend: () => void
}

const footerPrimaryBtnClass = cn(primaryBtnClass, 'text-sm normal-case')

export function ContractFormFooter({
  amountIncl,
  saving,
  onSaveAndSend,
}: Props) {
  const { t } = useTranslation('contracts')

  return (
    <footer className='sticky bottom-0 z-20 mt-auto -mx-6 -mb-6 border-t border-[#e7e9ef] bg-white px-16 pb-6 pt-4 shadow-[0_-1px_4px_0_rgba(38,45,66,0.05)]'>
      <div className='flex items-center gap-6'>
        <div className='min-w-0 flex-1'>
          <p className='text-xs font-medium leading-[1.4] text-[#6c7285]'>
            {t('form.footer.totalInclVat')}
          </p>
          <p className='font-heading text-base font-semibold leading-[1.2] tracking-[-0.48px] text-[#171a20]'>
            {formatCurrency(amountIncl, 'EUR', 2)}
          </p>
        </div>
        <Button
          type='button'
          className={footerPrimaryBtnClass}
          disabled={saving}
          onClick={onSaveAndSend}
        >
          <Send className='size-4' />
          {t('form.actions.sendToClient')}
        </Button>
      </div>
    </footer>
  )
}
